<div class="email-report-container">
  <!-- Header -->
<div class="dialog-header flex items-center justify-between">
  <div class="flex items-center gap-3">
    <span class="report-title flex items-center gap-2">
      <i class="pi pi-chart-bar"></i>
      Email Campaign Report
    </span>
   
  </div>
  <div class="absolute right-4">
     <button pButton type="button" icon="pi pi-refresh" label="Refresh" class="mr-3" (click)="refreshReport()" [disabled]="loading"></button>
    <button (click)="close()" class="text-white hover:text-gray-300">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container dialog-content">
    <p-progressSpinner></p-progressSpinner>
    <p class="loading-text">Loading report data...</p>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading && reportData" class="dialog-content report-content">
    
    <!-- Campaign Progress Section -->
    <div class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <div class="flex items-center justify-between flex-wrap gap-4">
        <!-- Sent Progress -->
        <div class="flex items-center gap-2">
          <span class="font-semibold text-gray-700">Progress:</span>
          <span class="text-lg font-bold text-blue-600">{{ statistics.sent }} / {{ totalNeedToSend }}</span>
          <span class="text-sm text-gray-600">({{ percentageOfCompletion }}% complete)</span>
        </div>
        
        <!-- Queued Count -->
        <div class="flex items-center gap-2">
          <span class="font-semibold text-gray-700">Queued:</span>
          <span class="text-lg font-bold text-orange-600">{{ queuedCount }}</span>
          <i class="pi pi-info-circle text-blue-500 cursor-help" 
             [pTooltip]="queuedCount + ' email' + (queuedCount !== 1 ? 's have' : ' has') + ' been queued to be sent the next day to avoid spam and maintain email reputation'"
             tooltipPosition="top"></i>
        </div>
      </div>
      
      <!-- Progress Bar -->
      <div class="mt-3">
        <p-progressBar [value]="percentageOfCompletion" [showValue]="false"></p-progressBar>
      </div>
    </div>
    
    <!-- Statistics Overview -->
    <div class="statistics-grid">
     
      <div class="stat-card stat-sent">
        <div class="stat-icon">
          <i class="pi pi-send"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Sent</p>
          <h3 class="stat-value">{{ statistics.sent }}</h3>
          <p class="stat-percentage">{{ statistics.total > 0 ? ((statistics.sent / totalNeedToSend) * 100).toFixed(1) : 0 }}%</p>
        </div>
      </div>

      <div class="stat-card stat-delivered">
        <div class="stat-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Delivered</p>
          <h3 class="stat-value">{{ statistics.uniqueDelivered || 0 }}</h3>
          <p class="stat-percentage">{{ statistics.total > 0 ? (((statistics.uniqueDelivered || 0) / totalNeedToSend) * 100).toFixed(1) : 0 }}%</p>
        </div>
      </div>

      <div class="stat-card stat-opened">
        <div class="stat-icon">
          <i class="pi pi-eye"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Opened</p>
          <h3 class="stat-value">{{ statistics.uniqueOpened || 0 }}</h3>
          <p class="stat-percentage">{{ statistics.opened }} total opens • {{ (statistics.uniqueDelivered && statistics.uniqueDelivered > 0) ? ((((statistics.uniqueOpened || 0) / (statistics.uniqueDelivered || 1)) * 100).toFixed(1)) : 0 }}%</p>
        </div>
      </div>

      <div class="stat-card stat-clicked">
        <div class="stat-icon">
          <i class="pi pi-paperclip"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Clicked</p>
          <h3 class="stat-value">{{ statistics.uniqueClicked || 0 }}</h3>
          <p class="stat-percentage">{{ statistics.clicked }} total clicks • {{ calculateClickRate().toFixed(1) }}%</p>
        </div>
      </div>

      <div class="stat-card stat-bounced">
        <div class="stat-icon">
          <i class="pi pi-exclamation-triangle"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Bounced</p>
          <h3 class="stat-value">{{ statistics.bounced }}</h3>
          <p class="stat-percentage">{{ calculateBounceRate().toFixed(1) }}%</p>
        </div>
      </div>

      <div class="stat-card stat-complained">
        <div class="stat-icon">
          <i class="pi pi-ban"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Complained</p>
          <h3 class="stat-value">{{ statistics.complained }}</h3>
        </div>
      </div>

      <div class="stat-card stat-rejected">
        <div class="stat-icon">
          <i class="pi pi-times-circle"></i>
        </div>
        <div class="stat-details">
          <p class="stat-label">Rejected</p>
          <h3 class="stat-value">{{ statistics.rejected }}</h3>
        </div>
      </div>
    </div>

    <!-- View Toggle -->
    <div class="view-toggle">
      <p-selectButton 
        [options]="[
          { label: 'Table View', value: 'table', icon: 'pi pi-table' },
          { label: 'Graph View', value: 'graph', icon: 'pi pi-chart-bar' }
        ]" 
        [(ngModel)]="activeView"
        optionLabel="label"
        optionValue="value">
        <ng-template let-item>
          <i [class]="item.icon"></i>
          <span class="ml-2">{{ item.label }}</span>
        </ng-template>
      </p-selectButton>
    </div>

    <!-- Table View -->
    <div *ngIf="activeView === 'table'" class="table-view">
      <!-- Status Tabs -->
      <div class="status-tabs">
        <div 
          *ngFor="let tab of statusTabs" 
          class="status-tab"
          [class.active]="activeTab === tab.value"
          (click)="filterDataByStatus(tab.value)">
          <i [class]="tab.icon"></i>
          <span class="tab-label">{{ tab.label }}</span>
          <span class="tab-count">{{ tab.count }}</span>
        </div>
      </div>

      <!-- Data Table -->
      <div class="data-table-container">
        <p-table 
          [value]="getDisplayData()" 
          [paginator]="true" 
          [rows]="10"
          [rowsPerPageOptions]="[10, 25, 50, 100]"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          styleClass="p-datatable-sm">
          
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let col of getDisplayColumns()" [pSortableColumn]="col.sortable ? col.field : ''">
                {{ col.header }}
                <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <!-- Grouped View (Opened/Clicked) -->
            <tr *ngIf="isGroupedView()">
              <td>
                <div class="email-cell">
                  <i class="pi pi-user"></i>
                  <span>{{ item.email_to }}</span>
                </div>
              </td>
              <td>
                <span class="event-count-badge">
                  <i class="pi pi-replay"></i>
                  {{ item.event_count }} {{ item.event_count === 1 ? 'time' : 'times' }}
                </span>
              </td>
              <td>
                <div class="timestamp-cell">
                  <i class="pi pi-clock"></i>
                  <span>{{ formatTimestamp(item.first_event) }}</span>
                </div>
              </td>
              <td>
                <div class="timestamp-cell">
                  <i class="pi pi-clock"></i>
                  <span>{{ formatTimestamp(item.last_event) }}</span>
                </div>
              </td>
            </tr>

            <!-- Regular View -->
            <tr *ngIf="!isGroupedView()">
              <td>
                <div class="email-cell">
                  <i class="pi pi-user"></i>
                  <span>{{ item.email_to }}</span>
                </div>
              </td>
              <td>
                <span class="event-type-badge">{{ item.event_type }}</span>
              </td>
              <td>
                <span class="status-badge" [ngClass]="getStatusBadgeClass(item.status)">
                  {{ item.status }}
                </span>
              </td>
              <td>
                <div class="timestamp-cell">
                  <i class="pi pi-clock"></i>
                  <span>{{ formatTimestamp(item.timestamp) }}</span>
                </div>
              </td>
              <!-- Message ID column removed -->
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="getDisplayColumns().length" class="text-center">
                <div class="empty-state">
                  <i class="pi pi-inbox"></i>
                  <p>No tracking data available for this status</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Graph View -->
    <div *ngIf="activeView === 'graph'" class="graph-view">
      <div class="charts-container">

           <!-- Key Metrics Card -->
        <div class="chart-card metrics-card">
          <div class="chart-header">
            <h3 class="chart-title">
              <i class="pi pi-info-circle"></i>
              Key Metrics
            </h3>
            <p class="chart-subtitle">Campaign performance indicators</p>
          </div>
          <div class="metrics-content">
            <div class="metric-item">
              <div class="metric-icon engagement">
                <i class="pi pi-eye"></i>
              </div>
              <div class="metric-info">
                <p class="metric-label">Engagement Rate</p>
                <p class="metric-value">{{ calculateEngagementRate().toFixed(2) }}%</p>
                <p class="metric-description">Opened / Delivered emails</p>
              </div>
            </div>

            <div class="metric-item">
              <div class="metric-icon click">
                <i class="pi pi-paperclip"></i>
              </div>
              <div class="metric-info">
                <p class="metric-label">Click-Through Rate</p>
                <p class="metric-value">{{ calculateClickRate().toFixed(2) }}%</p>
                <p class="metric-description">Clicked / Opened emails</p>
              </div>
            </div>

            <div class="metric-item">
              <div class="metric-icon bounce">
                <i class="pi pi-exclamation-triangle"></i>
              </div>
              <div class="metric-info">
                <p class="metric-label">Bounce Rate</p>
                <p class="metric-value">{{ calculateBounceRate().toFixed(2) }}%</p>
                <p class="metric-description">Bounced / Total emails</p>
              </div>
            </div>

            <div class="metric-item">
              <div class="metric-icon delivery">
                <i class="pi pi-check-circle"></i>
              </div>
              <div class="metric-info">
                <p class="metric-label">Delivery Rate</p>
                <p class="metric-value">{{ statistics.total > 0 ? ((statistics.delivered / statistics.total) * 100).toFixed(2) : 0 }}%</p>
                <p class="metric-description">Delivered / Total emails</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Status Distribution Chart -->
        <div class="chart-card">
          <div class="chart-header">
            <h3 class="chart-title">
              <i class="pi pi-chart-pie"></i>
              Status Distribution
            </h3>
            <p class="chart-subtitle">Email campaign status breakdown</p>
          </div>
          <div class="chart-content">
            <p-chart 
              type="doughnut" 
              [data]="statusChartData" 
              [options]="statusChartOptions"
              [style]="{ width: '100%', height: '400px' }">
            </p-chart>
          </div>
        </div>

        <!-- Event Comparison Chart -->
        <div class="chart-card">
          <div class="chart-header">
            <h3 class="chart-title">
              <i class="pi pi-chart-bar"></i>
              Event Comparison
            </h3>
            <p class="chart-subtitle">Comparison of email events</p>
          </div>
          <div class="chart-content">
            <p-chart 
              type="bar" 
              [data]="timelineChartData" 
              [options]="timelineChartOptions"
              [style]="{ width: '100%', height: '400px' }">
            </p-chart>
          </div>
        </div>

     

      </div>
    </div>

  </div>

  <!-- No Data State -->
  <div *ngIf="!loading && !reportData" class="dialog-content no-data-container">
    <i class="pi pi-chart-line"></i>
    <h3>No Report Data Available</h3>
    <p>There is no tracking data available for this campaign yet.</p>
  </div>

</div>
